require('/ui/components/table/table.module.scss.module.css');

export const htmlTableContainer = "_html-table-container_1y81a_1";
export const table = "_table_1y81a_1";
export const smallViewportSupport = "_small-viewport-support_1y81a_1";
export const tableWithFilters = "_table-with-filters_1y81a_1";
export const filterPanelContainer = "_filter-panel-container_1y81a_1";
export const tableAndControlsContainer = "_table-and-controls-container_1y81a_1";
